module.exports = __webpack_public_path__ + "d5becf27a07b7266c79dd4be2e6341f2.svg";